import { render, staticRenderFns } from "./UploadedPicture.vue?vue&type=template&id=edf0688e&"
import script from "./UploadedPicture.vue?vue&type=script&lang=ts&"
export * from "./UploadedPicture.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports